import axios from 'axios'
import config from '../apiConfig'
import url from '../baseUrl'

let baseUrl = url.salaryUrl

//预览电子合同
const $ajaxPreviewFile = params => axios.post(baseUrl + '/esign/previewFile', params);

//查询合同流程列表
//const $ajaxselectPageData = params => axios.post(baseUrl + '/contractprocedure/selectPageData', params, { config });

//预览流程
const $ajaxselectContractFile = params => axios.get(baseUrl + '/contractprocedure/selectContractFile', { params });

//催签
const $ajaxRushsignContract = params => axios.get(baseUrl + '/contractprocedure/rushsignContract', { params });

//撤销签约
const $ajaxRevokeContract = params => axios.get(baseUrl + '/contractprocedure/revokeContract', { params });

//获取签约地址
const $ajaxselectContractSignUrl = params => axios.get(baseUrl + '/contractprocedure/selectContractSignUrl', { params });

//合同查询列表
const $ajaxWorkerContractGetPageList = params => axios.get(baseUrl + '/workerContract/getPageList', { params });

//发起上线协议及，其他相关的
const $ajaxWorkerContractSignTerminated = params => axios.post(baseUrl + '/workerContract/signTerminated', params);

//发起保密协议，合同关系终止协议
const $ajaxSignBaoMiAndResign = params => axios.post(baseUrl + '/workerContract/signBaoMiAndResign', params);

//所有服务者信息
const $ajaxGetAllWorkerList = params => axios.get(baseUrl + '/workerSupplier/getAllWorkerList', { params });

//所有服务者信息
const $ajaxContractGetBjContract = params => axios.get(baseUrl + '/workerContract/getBjContract', { params });

//取消签署，针对服务合作协议105,针对 个人信息授权110
const $ajaxCancelSign = params => axios.get(baseUrl + '/workerContract/cancelSign', { params });
//服务者背调，不同于ocr识别，背调是校验犯罪
const $ajaxSingGerenxinxisouquan = params => axios.get(baseUrl + '/workerContract/singGerenxinxisouquan', { params });

//加盟商签署合同
const $ajaxJmsSignContract = params => axios.post(baseUrl + '/fraSignContract/jmsSignContract', params );
//加盟商合同查询列表
const $ajaxJmsContractGetPageList = params => axios.get(baseUrl + '/fraSignContract/getPageList', {params} );
//获取加盟商所有的账号，用来签署加盟商合同
const $ajaxJmsgetJMSAll = params => axios.get(baseUrl + '/signseal/getJMSAll', {params} );

//获取营业执照，选择某个公司创建eqb机构章和默认个人账号
const $ajaxgetNotCreatEQB = params => axios.get(baseUrl + '/signseal/getNotCreatEQB', {params} );
//选择创建一个加盟商的eqb账号
const $ajaxCreateOneEQBOrg = params => axios.post(baseUrl + '/signseal/createOneEQBOrg', params );

//发起肖像权使用协议书
const $ajaxSignUsePortraitRight = params => axios.post(baseUrl + '/workerContract/signUsePortraitRight', params );

export default {
    $ajaxPreviewFile,
    // $ajaxselectPageData,
    $ajaxselectContractFile,
    $ajaxRushsignContract,
    $ajaxRevokeContract,
    $ajaxselectContractSignUrl,
    $ajaxWorkerContractGetPageList,
    $ajaxWorkerContractSignTerminated,
    $ajaxSignBaoMiAndResign,
    $ajaxGetAllWorkerList,
    $ajaxContractGetBjContract,
    $ajaxCancelSign,
    $ajaxSingGerenxinxisouquan,

    $ajaxJmsSignContract,
    $ajaxJmsContractGetPageList,
    $ajaxJmsgetJMSAll,
    $ajaxgetNotCreatEQB,
    $ajaxCreateOneEQBOrg,
    $ajaxSignUsePortraitRight
}
